import type { VendorShipmentConfigResponse } from './api';

export const normalizeVendorShipmentConfig = (list: VendorShipmentConfigResponse): Record<string, boolean> => {
  if (!list) {
    return {};
  }
  return Object.fromEntries(list.map((item) => [item.columnName, Boolean(item.isVisible)]));
};
